<div class="ramadan-banner">
    <div class="ramadan-banner-background"></div>

    <div id='stars'></div>
    <div id='stars2'></div>
    <div id='stars3'></div>
    <div class="accessories">
        <img class="img-responsive" src="assets/img/ramadan20/accessories.png" alt="">
    </div>

    <div class="go_button sm square" routerLink="../home"
         style="position:absolute; top:20px; left:20px; z-index: 3; background:white; color:#333;">
        <i class="icon-left-open">Back To Games</i>
    </div>

    <div class="content">
        <div class="logo" style="display: flex; flex-flow: row">
            <img src="assets/img/ramadan20/ramadan-logo.svg" height="80" alt="" style="margin:0 5px">

            <img src="assets/img/games/{{gameName}}/logo.png" height="80" alt="" style="margin:0 5px">
        </div>
        <!--<h1>Ramadan Tournaments</h1>-->
        <div class="title">

            <p style="font-size:26px; font-family: proxima_novalight; text-align: center; margin: 0; line-height: 30px; ">Search and Destroy (SnD)<br>
                <span style="font-size:30px; font-family: proxima-nova-bold-webfont; margin: 0 ">
    25,000 EGP + 2,000,000 ZP
                                     <br>
                    <span style="font-size:12px; margin:0; font-family: proxima_novalight;">SND Tournaments are only restricted to Egypt</span>
    </span>
            </p>
            <p style="font-size:26px; font-family: proxima_novalight; text-align: center; margin: 0;  line-height: 30px; ">
                Free For All (FFA)<br>
                <span style="font-size:30px; font-family: proxima-nova-bold-webfont; margin: 0 ">
                1,200,000 ZP</span>

            </p>


            <!--<p style="color:#fde0c5; font-size: 14px; font-family: proxima-nova-bold-webfont">#StayHome_PlaySafe</p>-->


            <!--<p style="color:#fde0c5; font-size: 14px;">The ultimate way to entertain yourself in Ramadan</p>-->
        </div>
        <div class="partners_logo">
            <div class="flex_block" style="justify-content: center; align-items: center; flex-flow: row wrap;">
                <!--<img class="hidden-sm hidden-md hidden-lg" src="assets/img/ramadan20/pubg-logo.png" width="60" alt="">-->
                <img src="assets/img/ramadan20/smile-logo.png" width="60" alt="">
                <img src="assets/img/ramadan20/aorus-logo.png" width="100" alt="">
                <img src="assets/img/ramadan20/intel-logo.svg" width="60" alt="">
                <img src="assets/img/ramadan20/manlook-logo.svg" width="60" alt="">
                <!--<img src="assets/img/ramadan20/coco-logo.png" width="60" alt="">-->
                <img src="assets/img/ramadan20/ah-logo.png" width="40" alt="">
            </div>
        </div>
    </div>
    <div class="pillar r  hidden-xs hidden-sm">
        <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
    </div>
    <div class="pillar l hidden-xs">
        <img class="img-responsive" src="assets/img/ramadan20/pillar.png" alt="">
    </div>

    <!--<div class="content-gredient "></div>-->
</div>

<div class="wall">
    <div class="banner-footer"></div>

    <app-ramadan20-tournaments [gameName]="'crossfire'"></app-ramadan20-tournaments>

</div>
